import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  CardMedia,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

class PlanIntro extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSubmitting: false,
    }
  }

  submitRequest = () => {
    this.props.history.push({pathname: '/request', state: {step: 'occasion' }})
  }

  render() {
    const { classes, user } = this.props

    return (
      <Fragment>
        <Grid item xs={12} md={8}>
          <CardMedia
            component="img"
            className={classes.discoverImage}
            // image={'/personality-test.png'}
            image={'/travel-style-test.png'}
            srcSet="/travel-style-test@2x.png 2x,
                    /travel-style-test@3x.png 3x"
            title="Discover Weekly"
          />
        </Grid>
        <Grid item xs={12} md={8} className={classes.description}>
          {/* Create the perfect trip with ease. Our on-demand travel service generates a customized plan for your occasion and travel style in minutes.
          Get flight, hotel, and activity recommendations.

          <br/><br/>
          For a limited time, we're offering our service at a special discounted rate. Try it now with a 7-day money-back guarantee.
          <br/><br/>

          <div style={{fontWeight: 800, fontSize: 20, textAlign: 'center'}}>
            $4.99
            <span style={{textDecoration: 'line-through', color: '#828282', paddingLeft: 10}}> $9.99</span>
            <small style={{fontWeight: 500, fontSize: 14, color: '#828282', display: 'block', marginTop: 4}}>per travel plan</small>
          </div> */}

          Create the perfect trip with ease. Our on-demand travel service generates a customized plan for your occasion and travel style in minutes.
          <br/><br/>
          Get flight, hotel, and activity recommendations all for just $4.99. Try it now with a 7-day money-back guarantee.
        </Grid>
        <Grid item xs={12} md={8} style={{margin: 'auto', textAlign: 'center'}}>
          <Button disabled={this.state.isSubmitting} onClick={this.submitRequest} variant="contained" color="primary" size="large" className={classes.buttonBook}>
            {this.state.isSubmitting ?
              <Fragment>Sending...</Fragment>
              :
              <Fragment>Get started<Icon className="material-icons-outlined notranslate" style={{marginLeft: 10}}>east</Icon></Fragment>
            }
          </Button>
        </Grid>
      </Fragment>
    )
  }
}

const styles = theme => ({
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    },

    [theme.breakpoints.down('sm')]: {
      maxWidth: 450,
      margin: 'auto',
    },
  },
  discoverImage: {
    position: 'relative',
    display: 'block',
    marginLeft: -22,

    [theme.breakpoints.down('sm')]: {
      maxWidth: 450,
      margin: 'auto',
      paddingRight: 35,
    },
    ["@media (max-width: 500px)"]: {
      maxWidth: 450,
      marginLeft: '-15px',
      marginRight: 'auto',
    },
  },
  description: {
    padding: '20px 25px 10px 25px !important',
    textAlign: 'left',
    fontSize: 15,
    fontWeight: 500,

    [theme.breakpoints.down('sm')]: {
      padding: '20px 25px 10px 25px !important',
      maxWidth: 450,
    },

    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px !important',
    },
  }
})

export default withRouter(withStyles(styles)(PlanIntro))
